import { VF_INPUT } from 'AppSrc/core/components/forms/form-base-components/v-f-input';
import {
  INLINE_ERRORS,
  // SILENT_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { causedServiceOutage } from './caused-service-outage';
import { DURATION_OF_OUTAGE } from '../form-definition/section-constants';

const fieldId = DURATION_OF_OUTAGE;

const initialValues = '';

const vFParams = {
  fieldTitle: 'Duration of Outage (If Yes to above)',
  characterLimit: 20,
  placeholder: 'HH:MM',
};

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;


  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();
  // When causedServiceOutage field is "Yes" will do validate
  const shouldValidate = values[causedServiceOutage.id].includes('Yes') || values[causedServiceOutage.id].includes('10');

  if (shouldValidate) {
    /* ERROR CHECKERS */
    const noValue = commonValidation.noValue(values[fieldId], VF_INPUT);
    const overCharacterLimit = commonValidation.textInput.isOverCharacterLimit(values[fieldId], vFParams.characterLimit);

    /* ADD ERRORS TO ERROR OBJECT */
    // errors[INLINE_ERRORS].push((noValue && !optional) ? { withWarningSvg: true, className: 'textarea-area-warning' } : null);
    errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please enter the duration in HH:MM format' : null);
    errors[INLINE_ERRORS].push((overCharacterLimit) ? 'Text exceeds character limit' : null);
  }

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const durationOfOutage = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_INPUT,
};

export { durationOfOutage };
